import * as Types from '../../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentTermsOfUseQueryVariables = Types.Exact<{
  organisationUuid: Types.Scalars['String']['input'];
}>;


export type CurrentTermsOfUseQuery = { __typename?: 'Query', organisation: { __typename?: 'Organisation', id: string, name: string, termsOfUseTemplate: string, termsOfUse?: { __typename?: 'TermsOfUse', id: string, uuid: string, text: string } | null } };


export const CurrentTermsOfUseDocument = gql`
    query CurrentTermsOfUse($organisationUuid: String!) {
  organisation(uuid: $organisationUuid) {
    id
    name
    termsOfUse {
      id
      uuid
      text
    }
    termsOfUseTemplate
  }
}
    `;

/**
 * __useCurrentTermsOfUseQuery__
 *
 * To run a query within a React component, call `useCurrentTermsOfUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentTermsOfUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentTermsOfUseQuery({
 *   variables: {
 *      organisationUuid: // value for 'organisationUuid'
 *   },
 * });
 */
export function useCurrentTermsOfUseQuery(baseOptions: Apollo.QueryHookOptions<CurrentTermsOfUseQuery, CurrentTermsOfUseQueryVariables> & ({ variables: CurrentTermsOfUseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentTermsOfUseQuery, CurrentTermsOfUseQueryVariables>(CurrentTermsOfUseDocument, options);
      }
export function useCurrentTermsOfUseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentTermsOfUseQuery, CurrentTermsOfUseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentTermsOfUseQuery, CurrentTermsOfUseQueryVariables>(CurrentTermsOfUseDocument, options);
        }
// @ts-ignore
export function useCurrentTermsOfUseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentTermsOfUseQuery, CurrentTermsOfUseQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentTermsOfUseQuery, CurrentTermsOfUseQueryVariables>;
export function useCurrentTermsOfUseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentTermsOfUseQuery, CurrentTermsOfUseQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentTermsOfUseQuery | undefined, CurrentTermsOfUseQueryVariables>;
export function useCurrentTermsOfUseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentTermsOfUseQuery, CurrentTermsOfUseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentTermsOfUseQuery, CurrentTermsOfUseQueryVariables>(CurrentTermsOfUseDocument, options);
        }
export type CurrentTermsOfUseQueryHookResult = ReturnType<typeof useCurrentTermsOfUseQuery>;
export type CurrentTermsOfUseLazyQueryHookResult = ReturnType<typeof useCurrentTermsOfUseLazyQuery>;
export type CurrentTermsOfUseSuspenseQueryHookResult = ReturnType<typeof useCurrentTermsOfUseSuspenseQuery>;
export type CurrentTermsOfUseQueryResult = Apollo.QueryResult<CurrentTermsOfUseQuery, CurrentTermsOfUseQueryVariables>;